import { render, staticRenderFns } from "./preview-dsd.vue?vue&type=template&id=d820985c"
import script from "./preview-dsd.vue?vue&type=script&lang=js"
export * from "./preview-dsd.vue?vue&type=script&lang=js"
import style0 from "./preview-dsd.vue?vue&type=style&index=0&id=d820985c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports